function Poker() {
    return (
        <div>
            <h2>Poker View</h2>
            <iframe src="https://d3c9vg9lbcj3zk.cloudfront.net/stg/index.html" title="Poker" style={{ width: '100%', height: '80vh' }}></iframe>
        </div>
    );
}

export default Poker;